// @flow @jsx h

import { h } from 'preact'
import { Button } from './common/Button'
import styles from './StartView.css'
import { bem } from '@nrk/dh-utils'
import { start } from '../../config/text'

type Props = {
  onStartClick: () => void
}

const { titlePartOne, titlePartTwo, description, startButton } = start

const StartView = ({ onStartClick }: Props) => {
  return (
    <div class={styles.start}>
      <div>
        <h1
          class={styles.start__heading}
          aria-label={`${titlePartOne} ${titlePartTwo}`}
        >
          <span class={bem(styles['start__heading-span'], 'small')}>
            {titlePartOne}{' '}
          </span>
          <span class={bem(styles['start__heading-span'], 'large')}>
            {titlePartTwo}
          </span>
        </h1>
        <p class={styles.start__desc}>
          {description.map(content => (
            <span key={content} class={bem(styles['start__desc-span'])}>
              {content}{' '}
            </span>
          ))}
        </p>
      </div>

      <Button
        modifiers={['inverted', 'slim', 'bold', 'start']}
        onClick={onStartClick}
      >
        {startButton}
      </Button>
    </div>
  )
}

export { StartView }



// WEBPACK FOOTER //
// ./src/v1/components/Foreground/StartView.js